<script setup lang="ts">
import { toRefs } from 'vue';
import { IPolicyPackage } from '../../types/policy.type';
import { useI18n } from 'vue-i18n'

const { t } = useI18n();
interface Props {
  policyData: IPolicyPackage;
}
const props = defineProps<Props>();
const { policyData } = toRefs(props);
</script>

<template>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_package.id') }}: </strong>
	  {{ policyData.id }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_package.limite_indemnizacion') }}: </strong>
	  $ {{ policyData.indemnificationLimit }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_package.precio_total') }}: </strong>
	  $ {{ policyData.fullPrice }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_package.limite_indemnizacion') }}: </strong>
	  $ {{ policyData.indemnificationLimit }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_package.cliente') }}: </strong>
	  {{ policyData.client.tradeName }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_package.direccion_cliente') }}: </strong>
	  {{ policyData.client.address }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_package.telefono_cliente') }}: </strong>
	  {{ policyData.client.phone1 }}
	</p>
	<p v-if="policyData.client.rfc">
	  <strong>{{ t('operaciones.modal_content_policy_package.rfc_cliente') }}: </strong>
	  {{ policyData.client.rfc }}
	</p>
	<p v-if="policyData.client.cuit">
	  <strong>{{ t('operaciones.modal_content_policy_package.cuit_cliente') }}: </strong>
	  {{ policyData.client.cuit }}
	</p>
	<p v-if="policyData.client.rut">
	  <strong>{{ t('operaciones.modal_content_policy_package.rut_cliente') }}: </strong>
	  {{ policyData.client.rut }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_package.compania_gps') }}: </strong>
	  {{ policyData.companyGPS.description }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_package.pais') }}: </strong>
	  {{ policyData.country.description }}
	</p>
	<p>
	  <strong>{{ t('operaciones.modal_content_policy_package.numeros_guias') }}: </strong>
	  {{ policyData.numbersGuides }}
	</p>
  </template>
  
